// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2UVzS","colCheckbox":"styles_colCheckbox__18Kqz"};